import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import CartItem from "../../components/cart/CartItem";
import CartSummary from "../../components/cart/CartSummary";
import EmptyState from "../../components/common/EmptyState";

const CartPage = () => {
  const { items, updateQty, removeItem, updateItemVariant, subtotal, discount, total } = useCart();
  const onQtyChange = (item, qty) => updateQty(item.product_id, item.size, item.color || "", qty);
  const onRemove = (item) => removeItem(item.product_id, item.size, item.color || "");
  const onVariantChange = (item, nextSize, nextColor) => updateItemVariant(item.product_id, item.size, item.color || "", nextSize, nextColor);

  return (
    <div className="pt-24 px-4 md:px-8 lg:px-12 pb-24" data-testid="cart-page">
      <h1 className="font-anton text-5xl md:text-7xl uppercase mb-10">Cart.</h1>
      {items.length === 0 ? (
        <EmptyState
          title="Your cart is empty."
          message="Add a tee first, then come back to check out."
          action={<Link to="/shop" className="bg-white text-black px-8 py-4 font-mono text-xs uppercase tracking-[0.2em]">Browse Drops</Link>}
        />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-8">
          <div className="space-y-4">
            {items.map((item) => (
              <CartItem
                key={`${item.product_id}-${item.size}-${item.color || ""}`}
                item={item}
                onQtyChange={onQtyChange}
                onRemove={onRemove}
                onVariantChange={onVariantChange}
              />
            ))}
          </div>
          <CartSummary items={items} subtotal={subtotal} discount={discount} total={total} disabled={items.length === 0} />
        </div>
      )}
    </div>
  );
};

export default CartPage;
